import React, { useState, useEffect, useMemo } from 'react';
import ProductGrid from './ProductGrid';
import ShopControls from './ShopControls';
import './Shop.css';

// --- Import your local images from your assets folder ---
import xboxRamImage from '../../Assets/Images/XboxRamUpgrade.JPG';
import xboxModchipImage from '../../Assets/Images/XboxModchip.JPG';
import xboxRamBundleImage from '../../Assets/Images/XboxOXRAMCAPBundle.JPG';
import gameboyBatteryImage from '../../Assets/Images/Logo Black BG.png';
import switchPortImage from '../../Assets/Images/Logo Black BG.png';
import xboxRecapImage from '../../Assets/Images/XboxRecap.JPG';
import xboxUltimateBundleImage from '../../Assets/Images/XboxOXRAMCAPBundle.JPG';
import stickerImage from '../../Assets/Images/Logo Black BG.png';


const allProducts = [
  {
    id: 2,
    name: 'Xbox 128MB RAM Installation Service',
    description: 'Upgrade your original Xbox console from 64MB to 128MB of RAM. Essential for advanced homebrew and emulation.',
    category: 'Services',
    subCategory: 'Video Games',
    brand: 'Microsoft',
    imageUrl: xboxRamImage,
    // --- FINAL LOGIC ---
    // Base Price (Labor Only): $100.00
    // Parts Cost (Add-on): +$20.00
    // Total Price with Parts: $120.00
    basePrice: 100.00,
    options: {
      'RAM Chips': [
        { name: 'I will provide my own', priceModifier: 0 },
        { name: 'Please provide them (+$20)', priceModifier: 20 }
      ]
    }
  },
  {
    id: 3,
    name: 'Xbox Open Xenium Installation Service',
    description: 'Installation of the Open Xenium modchip for the original Xbox, allowing custom dashboards and homebrew applications.',
    category: 'Services',
    subCategory: 'Video Games',
    brand: 'Microsoft',
    imageUrl: xboxModchipImage,
    // --- FINAL LOGIC ---
    // Base Price (Labor Only): $50.00
    // Parts Cost (Add-on): +$50.00
    // Total Price with Parts: $100.00
    basePrice: 50.00,
    options: {
      'Modchip': [
        { name: 'I will provide my own', priceModifier: 0 },
        { name: 'Please provide one (+$50)', priceModifier: 50 }
      ]
    }
  },
  {
    id: 4,
    name: 'Xbox RAM + Modchip Bundle',
    description: 'This bundle includes both the 128MB RAM upgrade and Open Xenium modchip installation.',
    category: 'Services',
    subCategory: 'Video Games',
    brand: 'Microsoft',
    imageUrl: xboxRamBundleImage,
    // --- FINAL LOGIC ---
    // Base Price (Labor Only): $140.00
    // Parts Cost (Add-on): +$60.00
    // Total Price with Parts: $200.00
    basePrice: 140.00,
    options: {
      'Parts': [
        { name: 'I will provide all parts', priceModifier: 0 },
        { name: 'Please provide all parts (+$60)', priceModifier: 60 }
      ]
    }
  },
  {
    id: 5,
    name: 'Gameboy Cartridge Battery Replacement',
    description: 'Breathe new life into your classic Gameboy, GBC, and GBA game cartridges by replacing their old, non-working save batteries.',
    category: 'Services',
    subCategory: 'Video Games',
    brand: 'Nintendo',
    imageUrl: gameboyBatteryImage,
    basePrice: 10.00,
  },
  {
    id: 6,
    name: 'Switch USB-C Port Replacement Service',
    description: 'Professional repair service for a faulty or damaged USB-C charging port on any model of the Nintendo Switch.',
    category: 'Services',
    subCategory: 'Video Games',
    brand: 'Nintendo',
    imageUrl: switchPortImage,
    // --- FINAL LOGIC ---
    // Base Price (Labor Only): $50.00
    // Parts Cost (Add-on): +$10.00
    // Total Price with Parts: $60.00
    basePrice: 50.00,
    options: {
      'USB-C Port': [
        { name: 'I will provide my own', priceModifier: 0 },
        { name: 'Please provide one (+$10)', priceModifier: 10 }
      ]
    }
  },
  {
    id: 7,
    name: 'Original Xbox Full Capacitor Replacement',
    description: 'Preventative maintenance to replace all capacitors on the Xbox motherboard, ensuring longevity and fixing common power issues.',
    category: 'Services',
    subCategory: 'Video Games',
    brand: 'Microsoft',
    imageUrl: xboxRecapImage,
    // --- FINAL LOGIC ---
    // Base Price (Labor Only): $60.00
    // Parts Cost (Add-on): +$20.00
    // Total Price with Parts: $80.00
    basePrice: 60.00,
    options: {
      'Capacitors': [
        { name: 'I will provide my own', priceModifier: 0 },
        { name: 'Please provide them (+$20)', priceModifier: 20 }
      ]
    }
  },
  {
    id: 8,
    name: 'Xbox Ultimate Overhaul Bundle',
    description: 'The complete package! Includes 128MB RAM upgrade, Open Xenium modchip installation, and a full capacitor replacement.',
    category: 'Services',
    subCategory: 'Video Games',
    brand: 'Microsoft',
    imageUrl: xboxUltimateBundleImage,
    // --- FINAL LOGIC ---
    // Base Price (Labor Only): $190.00
    // Parts Cost (Add-on): +$75.00
    // Total Price with Parts: $265.00
    basePrice: 190.00,
    options: {
      'Parts': [
        { name: 'I will provide all parts', priceModifier: 0 },
        { name: 'Please provide all parts (+$75)', priceModifier: 75 }
      ]
    }
  },
  {
    id: 9,
    name: 'Cowdog Technologies Holographic Sticker',
    description: 'High-quality, durable holographic vinyl sticker featuring the Cowdog Technologies logo. Perfect for your console, laptop, or toolbox.',
    category: 'Accessories',
    imageUrl: stickerImage,
    basePrice: 0.99,
    options: {
      'Size': [
        { name: '2x2 inch', priceModifier: 0 },
      ]
    }
  },
];

const ShopPage = () => {
  const [products, setProducts] = useState([]);
  const [filters, setFilters] = useState({ category: 'all', subCategory: 'all', brand: 'all' });
  const [sortBy, setSortBy] = useState('name-asc');

  useEffect(() => {
    setProducts(allProducts);
  }, []);

  const displayedProducts = useMemo(() => {
    let processedProducts = [...products];

    if (filters.category !== 'all') {
      processedProducts = processedProducts.filter(p => p.category === filters.category);
    }
    if (filters.subCategory !== 'all') {
      processedProducts = processedProducts.filter(p => p.subCategory === filters.subCategory);
    }
    if (filters.brand !== 'all') {
        processedProducts = processedProducts.filter(p => p.brand === filters.brand);
    }

    processedProducts.sort((a, b) => {
      switch (sortBy) {
        case 'price-asc':
          return a.basePrice - b.basePrice;
        case 'price-desc':
          return b.basePrice - a.basePrice;
        case 'name-desc':
          return b.name.localeCompare(a.name);
        case 'name-asc':
        default:
          return a.name.localeCompare(b.name);
      }
    });

    return processedProducts;
  }, [products, filters, sortBy]);

  return (
    <div className="shop-container">
      <main className="main-content-shop">
        <ShopControls
          filters={filters}
          setFilters={setFilters}
          sortBy={sortBy}
          setSortBy={setSortBy}
        />
        <ProductGrid products={displayedProducts} />
      </main>
    </div>
  );
};

export default ShopPage;